<template>
  <div class="r-table">
    <h3 class="tit">{{title}}</h3>
    <table class="tb">
      <tbody>
        <tr>
          <th>账号</th>
          <th v-if="config_info.sale_extend!=='1'">等级</th>
          <th v-if="config_info.sale_extend!=='1'">等级礼金</th>
          <th v-if="config_info.sale_extend!=='1'" v-show="config_info.week_salary_status === '1'">周俸禄</th> 
          <th v-if="config_info.sale_extend!=='1'" v-show="config_info.month_salary_status === '1'">月俸禄</th>
          <th v-if="config_info.sale_extend==='1'">VIP等级</th>
          <th v-if="config_info.sale_extend==='1'">电子等级</th>
          <th v-if="config_info.sale_extend==='1'">真人等级</th> 
          <th>标价</th>
          <th v-if="type===1">出价</th>
          <th>成交价格</th>
          <th>状态</th>
          <th>操作</th>
        </tr>
        <tr v-if="!list.length" class="tr_sec">
          <td colspan="10" rowspan="" headers="" v-if="type===1">暂无数据</td>
          <td colspan="9" rowspan="" headers="" v-if="type===2">暂无数据</td>
        </tr>
        <tr v-else v-for="item in list" v-bind:key="item.id">
          <td>{{item.account}}</td>
          <td v-if="config_info.sale_extend!=='1'">{{item.e_level}}</td>
          <td v-if="config_info.sale_extend!=='1'">{{item.e_up_reward}}</td>
          <td v-if="config_info.sale_extend!=='1'" v-show="config_info.week_salary_status === '1'">{{item.e_week_reward}}</td>
          <td v-if="config_info.sale_extend!=='1'" v-show="config_info.month_salary_status === '1'">{{item.e_month_reward}}</td>
          <td v-if="config_info.sale_extend==='1'">{{item.vip_level}}</td>
          <td v-if="config_info.sale_extend==='1'">{{item.e_level}}</td>
          <td v-if="config_info.sale_extend==='1'">{{item.r_level}}</td>
          <td>{{item.sale_price}}</td>
          <td v-if="type===1">{{item.buy_price}}</td>
          <td v-if="type===1">
            <template v-if="item.status == 4">
              {{item.deal_price}}
            </template>
            <template v-else>-</template>
          </td>
          <td v-if="type===2">
            <template v-if="item.status == 3">
              {{item.deal_price}}
            </template>
            <template v-else>-</template>
          </td>
          <td>{{formatBuyStatus(item.status)}}</td>
          <td class="detail" v-if="item.status == 4 && type == 1">
            <a class="t-btn" @click="toNewPageOne(item)" target="_blank">查看详情</a>
          </td>
          <td class="detail" v-else>
            <a class="t-btn" @click="toNewPage(item)" target="_blank">查看详情</a>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="page" v-if="list.length">
      <div class="p-l">
        <p class="total">共{{page.total_count}}条记录,{{page.total_page}}页,每页{{page.page_size}}条记录</p>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page.page_current"
          :page-size="page.page_size"
          layout="prev, pager, next"
          :total="page.total_count"
          prev-text="上一页"
          next-text="下一页"
          >
        </el-pagination>
      </div>
      <!-- <el-pagination
        @current-change="handleCurrentChange"
        :current-page="page.page_current"
        :page-size="page.page_size"
        layout="slot"
        :total="page.total_count"
        >
        <ul class="jumper">
          <li>每页显示:</li>
          <li v-for="item in sizes" v-bind:key="item.id" @click="handleSizeChange(item)">{{item}}</li>
        </ul>
      </el-pagination> -->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'recordlist',
  props: {
      title: {
        type: String
      },
      type: {
        type: Number,
        default: 1 // 1 buy 2 sell
      },
      list: {
        type: Array
      },
      page: {
        type: Object
      }
  },
  computed: {
      ...mapState(['config_info'])
    },
  methods: {
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
      this.$emit('changepagesize', val)
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`)
      this.$emit('changepage', val)
    },
    toNewPage(data) {
      let id
      if (this.type === 1) { id = data.sale_id }
      if (this.type === 2) { id = data.id }
      window.open(window.location.origin + '/acc-detail/' + id)
    },
    toNewPageOne(data) {
      let id
      if (this.type === 1) { id = data.sale_id }
      window.open(window.location.origin + '/acc-detail/' + id + '?code=1')
    },
    formatBuyStatus(status) {
      let ret = ''
      if (this.type === 1) {
        switch (status) {
          case 0:
            ret = '报价待审核'
            break
          case 1:
            ret = '报价同意，订单处理中'
            break
          case 2:
            ret = '报价同意，订单处理中'
            break
          case 3:
            ret = '报价不同意'
            break
          case 4:
            ret = '交易成功'
            break
          case 5:
            ret = '其他人已购买'
            break
          default:
            break
        }
      } else if (this.type === 2) {
        switch (status) {
          case 0:
            ret = '待审核'
            break
          case 1:
            ret = '出售中'
            break
          case 2:
            ret = '审核失败'
            break
          case 3:
            ret = '交易成功'
            break
          case 4:
            ret = '交易关闭'
            break
          default:
            break
        }
      }
      return ret
    },
    formatFinal(item) {
      let ret
      return ret
    }
  }
}
</script>

<style lang="stylus" scoped>
.r-table
  padding 0 50px 20px
  .tit
    margin-top 25px
    color $primary
    font-size 14px
  .tb
    margin-top 25px
    width 100%
    white-space nowrap
    border-collapse collapse
    border solid 1px #dcdcdc
    & > tbody
      tr
        & > th
          line-height 40px
          background #efefef
          white-space nowrap
          color #626262
          text-align center
          font-size 14px
          font-weight normal
          border-top solid 1px #dcdcdc
          border-right solid 1px #dcdcdc
          position relative
        & > td
          line-height 40px
          background #fff
          white-space nowrap
          color #626262
          text-align center
          font-size 14px
          font-weight normal
          border-top solid 1px #dcdcdc
          border-right solid 1px #dcdcdc
          position relative
          &.detail
            & > a
              color #ff4800
              text-decoration underline
              cursor pointer
      .tr_sec
        text-align center
        padding-top 10px
        border 1px solid #dcdcdc
  .page
    border solid 1px #dcdcdc
    border-top none
    display flex
    align-items center
    justify-content space-between
    height 42px
    .p-l
      display flex
      .total
        height 30px
        border solid 1px #dcdcdc
        padding 0 10px
        color #626262
        font-size 14px
        line-height 30px
        margin-left 5px
</style>



// WEBPACK FOOTER //
// recordlist.vue?145d91f4